var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverrideCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "#8F8F8F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C10.8634 0 14 3.36062 14 7.5C14 11.6394 10.8634 15 7 15C3.13658 15 0 11.6394 0 7.5C0 3.36062 3.13658 0 7 0ZM7 0.625C10.5414 0.625 13.4167 3.70563 13.4167 7.5C13.4167 11.2944 10.5414 14.375 7 14.375C3.45858 14.375 0.583333 11.2944 0.583333 7.5C0.583333 3.70563 3.45858 0.625 7 0.625ZM7 7.05813L10.0876 3.75L10.5 4.19187L7.41242 7.5L10.5 10.8081L10.0876 11.25L7 7.94187L3.91242 11.25L3.5 10.8081L6.58758 7.5L3.5 4.19187L3.91242 3.75L7 7.05813Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverrideCross);
export default __webpack_public_path__ + "static/media/override-cross.269372c2.svg";
export { ForwardRef as ReactComponent };